export default __webpack_public_path__ + "static/media/CoachingScreen.cc4e8982.png";